
$('.testimonials-right').slick({
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 2,
    autoplay: true,
    arrows: false,
    dots: true,
    responsive: [
        {
            breakpoint: 766,
            settings: {
                slidesToShow: 2,
            }
        },
        {
            breakpoint: 534,
            settings: {
                slidesToShow: 1,
            }
        }
    ]
});